import { DateTime } from 'luxon'

export enum ZoneStateStatus {
	ONLINE = 'ONLINE',
	WARNING = 'WARNING',
	OFFLINE = 'OFFLINE',
	NOT_INSTALLED = 'NOT_INSTALLED',
	NOT_REACTIVATED = 'NOT_REACTIVATED',
}

export enum ZoneStateState {
	PLAYING = 'playing',
	DOWNLOADING = 'downloading',
	WAITING = 'waiting',
}

export class ZoneState {
	public status: ZoneStateStatus
	public warnings: ZoneStateWarning[]
	public lastSeen: DateTime | null
	public startedPlaying: DateTime | null
	public appVersion: string | null
	public osVersion: string | null
	public state: ZoneStateState | null
	public volume: number | null
	public audioDevice: string | null
	public lastUpdated: DateTime | null

	constructor(data: {
		status: ZoneStateStatus
		warnings: ZoneStateWarning[]
		lastSeen: DateTime | null
		startedPlaying: DateTime | null
		appVersion: string | null
		osVersion: string | null
		state: ZoneStateState | null
		volume: number | null
		audioDevice: string | null
		lastUpdated: DateTime | null
	}) {
		this.status = data.status
		this.warnings = data.warnings
		this.lastSeen = data.lastSeen
		this.startedPlaying = data.startedPlaying
		this.appVersion = data.appVersion
		this.osVersion = data.osVersion
		this.state = data.state
		this.volume = data.volume
		this.audioDevice = data.audioDevice
		this.lastUpdated = data.lastUpdated
	}

	static create(partial: Partial<ZoneState>): ZoneState {
		const defaults = {
			status: ZoneStateStatus.NOT_INSTALLED,
			warnings: [],
			lastSeen: null,
			startedPlaying: null,
			appVersion: null,
			osVersion: null,
			state: null,
			volume: null,
			audioDevice: null,
			lastUpdated: null,
		}

		// Merge defaults with provided data
		return new ZoneState({ ...defaults, ...partial })
	}

	isOnline(): boolean {
		return (
			this.status === ZoneStateStatus.ONLINE ||
			this.status === ZoneStateStatus.WARNING
		)
	}
}

export enum ZoneStateWarningCode {
	IDLE = 'messages.player.status.idle',
	DOWNLOADING = 'messages.player.status.downloading',
	OS_OUTDATED = 'messages.player.status.os_version',
	AUDIO_MUTED = 'messages.player.status.muted',
	LOW_VOLUME = 'messages.player.status.volume',
	NO_AUDIO_DEVICE = 'messages.player.status.audio_device',
	PLAYER_OUTDATED = 'messages.player.status.outdated',
	WRONG_TIME_OR_TIMEZONE = 'messages.player.status.wrong_timezone',
	WITHOUT_SPACE = 'messages.player.status.without_space',
}

export class ZoneStateWarning {
	public code: string
	public message: string
	public email: string

	constructor(data: { code: string; message: string; email: string }) {
		this.code = data.code
		this.message = data.message
		this.email = data.email
	}

	static create(partial: Partial<ZoneStateWarning>): ZoneStateWarning {
		const defaults = {
			code: '',
			message: '',
			email: '',
		}
		return new ZoneStateWarning({ ...defaults, ...partial })
	}
}
